import {
  AutomaticStatusWaiting,
  TimestampStatusCreating,
} from '@/features/approving_invoice_reports/types/status';
import { faker } from '@faker-js/faker';
import { ApReportStatus } from 'ap-openapi';
import { HttpResponse, delay, http } from 'msw';
import { FIXED_REF_DATE } from '../../constants';

export const getGetReportSummaryMock = () => ({
  agent_applicant_office_member_name: faker.helpers.arrayElement([
    faker.word.sample(),
  ]),
  approved_at: faker.helpers.arrayElement([
    `${
      faker.date.past({ refDate: FIXED_REF_DATE }).toISOString().split('.')[0]
    }Z`,
  ]),
  created_at: faker.helpers.arrayElement([
    `${
      faker.date.past({ refDate: FIXED_REF_DATE }).toISOString().split('.')[0]
    }Z`,
  ]),
  foreign_currency_amount: faker.helpers.arrayElement([faker.word.sample()]),
  id: faker.helpers.arrayElement([faker.word.sample()]),
  is_approvable: faker.helpers.arrayElement([faker.datatype.boolean()]),
  is_editable: faker.helpers.arrayElement([faker.datatype.boolean()]),
  is_report_approval: faker.helpers.arrayElement([faker.datatype.boolean()]),
  number: faker.helpers.arrayElement([faker.word.sample()]),
  office_member: faker.helpers.arrayElement([
    {
      display_name: faker.helpers.arrayElement([faker.word.sample()]),
      id: faker.helpers.arrayElement([faker.word.sample()]),
      name: faker.helpers.arrayElement([faker.word.sample()]),
    },
  ]),
  report_dept: faker.helpers.arrayElement([
    {
      id: faker.helpers.arrayElement([faker.word.sample()]),
      name: faker.helpers.arrayElement([faker.word.sample()]),
    },
  ]),
  status: faker.helpers.arrayElement([
    faker.helpers.arrayElement(Object.values(ApReportStatus)),
  ]),
  submitted_at: faker.helpers.arrayElement([
    `${
      faker.date.past({ refDate: FIXED_REF_DATE }).toISOString().split('.')[0]
    }Z`,
  ]),
  tax_rate_items: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      excise_values: faker.helpers.arrayElement([faker.word.sample()]),
      subtotal: faker.helpers.arrayElement([faker.word.sample()]),
      subtotal_with_tax: faker.helpers.arrayElement([faker.word.sample()]),
      tax_rate: faker.helpers.arrayElement([faker.word.sample()]),
    })),
  ]),
  title: faker.helpers.arrayElement([faker.word.sample()]),
  total_excise_value: faker.helpers.arrayElement([faker.word.sample()]),
  total_transaction_details_value: faker.helpers.arrayElement([
    faker.word.sample(),
  ]),
  total_value: faker.helpers.arrayElement([faker.word.sample()]),
  total_withholding_income_tax_value: faker.helpers.arrayElement([
    faker.word.sample(),
  ]),
});

export const getGetApprovingInvoiceReportJournalMock = () => ({
  entries: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      cr_counterparty_name: faker.helpers.arrayElement([
        faker.word.sample({ length: 2000 }),
      ]),
      cr_dept_name: faker.helpers.arrayElement([
        faker.word.sample({ length: 300 }),
      ]),
      cr_display_amount: faker.helpers.arrayElement([faker.word.sample()]),
      cr_display_purchase_tax_credit: faker.helpers.arrayElement([
        faker.word.sample(),
      ]),
      cr_excise_name: faker.helpers.arrayElement([faker.word.sample()]),
      cr_invoice_kind: faker.helpers.arrayElement([faker.word.sample()]),
      cr_item_name: faker.helpers.arrayElement([faker.word.sample()]),
      cr_project_code_name: faker.helpers.arrayElement([faker.word.sample()]),
      cr_sub_item_name: faker.helpers.arrayElement([faker.word.sample()]),
      dr_counterparty_name: faker.helpers.arrayElement([faker.word.sample()]),
      dr_dept_name: faker.helpers.arrayElement([faker.word.sample()]),
      dr_display_amount: faker.helpers.arrayElement([faker.word.sample()]),
      dr_display_purchase_tax_credit: faker.helpers.arrayElement([
        faker.word.sample(),
      ]),
      dr_excise_name: '',
      dr_invoice_kind: faker.helpers.arrayElement([faker.word.sample()]),
      dr_item_name:
        'long long name using here to test long long name using here to test',
      dr_project_code_name: faker.helpers.arrayElement([faker.word.sample()]),
      dr_sub_item_name: '',
    })),
  ]),
  entry_fields: [
    'dr_item_name',
    'dr_sub_item_name',
    'dr_dept_name',
    'dr_project_code_name',
    'dr_counterparty_name',
    'dr_invoice_kind',
    'dr_display_amount',
    'cr_item_name',
    'cr_sub_item_name',
    'cr_dept_name',
    'cr_project_code_name',
    'cr_counterparty_name',
    'cr_invoice_kind',
    'cr_display_amount',
    'dr_excise_name',
    'cr_excise_name',
    'dr_display_purchase_tax_credit',
    'cr_display_purchase_tax_credit',
  ],
});

export const getGetPaymentInfoMock = () => {
  const files = faker.helpers.arrayElement([
    `請求書${faker.number.int({
      min: 1,
      max: 2,
    })}.pdf`,
    'image.jpg',
  ]);

  return {
    receipt_type: 'paper',
    report_form_inputs: [
      {
        id: 'F8y3sxbxPakNTZHpB9ibTA',
        label: '支払先種別',
        type: 'ApReportFormInputInvoicePayeeType',
        input_values: [
          { id: '6UYJDFR12P08Vvrv4T9O0w', label: '1005', value: '1005' },
        ],
        input_additional_values: null,
      },
      {
        id: 'rZ96tF6EzgWsxA6g_wPxfA',
        label: '支払先',
        type: 'ApReportFormInputInvoicePayeeSelect',
        input_values: [
          {
            id: 'MYstWd5p4OzuZPbOHcf9eA',
            label: 'Tom Nguyen（133222112）（銀行口座振込）',
            value: 'i0LAkK8hbNPbRL5C9I5vew',
          },
        ],
        input_additional_values: null,
      },
      {
        id: 'aVB6OHEi1hOG09giqF0v8A',
        label: '特例区分',
        type: 'ApReportFormInputSpecialExceptionStatus',
        input_values: [
          {
            id: 'F8y3sxbxPakNTZHpB9ibTA',
            label: '自販機等(3万円未満)',
            value: 'xWevLsCeD3lNR8JTH5vfrg',
          },
        ],
        input_additional_values: [
          {
            id: 'N5yLO_aNpvuekQdvLI_ptA',
            address_or_location: 'hj',
            ap_special_exception_status: {
              id: 'xWevLsCeD3lNR8JTH5vfrg',
              ap_special_exception_status_master_id: 4,
              is_active: true,
              custom_remark: '自販機特例',
              name: '自販機等(3万円未満)',
              disp_order: 4,
            },
          },
        ],
      },
      {
        id: 'ktPMUL5PTrSAqBAwTwK1LQ',
        label: '適格請求書発行事業者登録番号',
        type: 'ApReportFormInputInvoiceRegistrationNumberField',
        input_values: [
          {
            id: '6r9rWgVfeIXf5VapzmuBjw',
            label: 'T2332222322232',
            value: '1234567891234',
          },
        ],
        input_additional_values: [
          {
            is_mismatched: false,
          },
        ],
      },
      {
        id: 'lDSxz4n4tNmyoHX4r3CigA',
        label: '請求書画像',
        type: 'ApReportFormInputInvoiceFileField',
        input_values: [
          {
            id: 'HDtz9a8wca8OZfnxCLCdOQ',
            label:
              '\u003ca href="/mf_files/JRv8nGG-cDMPBxlMQcCXLQ"\u003emultiple_page.pdf\u003c/a\u003e',
            value: 'JRv8nGG-cDMPBxlMQcCXLQ',
          },
        ],
        input_additional_values: [
          {
            id: files,
            cache_content_url: '/mf_files/JRv8nGG-cDMPBxlMQcCXLQ',
            can_delete: false,
            byte_size: 98538,
            content_type: 'application/pdf',
            name: 'multiple_page.pdf',
            e_doc_meta_datum: {
              is_scan: faker.datatype.boolean(),
              is_satisfy_resolution_requirement: faker.helpers.arrayElement([
                faker.datatype.boolean(),
              ]),
              is_satisfy_depth_requirements: faker.helpers.arrayElement([
                faker.datatype.boolean(),
              ]),
              dpi_text: `${faker.number.int({ min: 30, max: 600 })} dpi`,
              pixel_number_text: `${faker.number.int({
                min: 1,
                max: 50,
              })}万画素`,
              width_and_height_pixel_text: `${faker.number.int({
                min: 800,
                max: 4000,
              })} * ${faker.number.int({ min: 600, max: 3000 })}`,
              rgb_depth_text: `RGB(${faker.number.int({
                min: 100,
                max: 256,
              })}, ${faker.number.int({
                min: 100,
                max: 256,
              })}, ${faker.number.int({
                min: 100,
                max: 256,
              })})`,
            },
            invoice_number: 'IV-4',
            receipt_type: 'paper',
          },
        ],
      },
      {
        id: 'r-ka4_b_SlIMFd0JUPnmsg',
        label: '請求書受領区分',
        type: 'ApReportFormInputReceiptType',
        input_values: [
          {
            id: 'aVB6OHEi1hOG09giqF0v8A',
            label: '電子 (PDF,JPEG等) で受領した請求書',
            value: '1003',
          },
        ],
        input_additional_values: null,
      },
      {
        id: 'g8luUEVnEm5ptVEADhJ4EQ',
        label: '取引関係書類',
        type: 'ApReportFormInputBusinessDocumentsField',
        input_values: [
          {
            id: 'ktPMUL5PTrSAqBAwTwK1LQ',
            label:
              'Doc-4：multiple_page.pdf,Doc-3：multiple_excise + multiple item.pdf,Doc-2：multiple_page.pdf,Doc-1：invoice.jpg',
            value:
              'cqOAYGirucwN-IWVnLuRaw,N5yLO_aNpvuekQdvLI_ptA,i0LAkK8hbNPbRL5C9I5vew,wXsJZNcoaRpfVBRhdlGMFQ',
          },
        ],
        input_additional_values: [
          {
            id: 'wXsJZNcoaRpfVBRhdlGMFQ',
            document_title: 'multiple_page.pdf',
            document_number: 'Doc-4',
            document_type: 'purchase_order',
            mf_file: {
              id: 'xpbcR-YP_n639KdLslY-SQ',
              cache_content_url: '/mf_files/JRv8nGG-cDMPBxlMQcCXLQ',
              can_delete: false,
              byte_size: 107884,
              content_type: 'application/pdf',
              name: 'multiple_page_20250829124128.pdf',
              timestamp_status: 'done',
              e_doc_meta_datum: {
                is_scan: faker.datatype.boolean(),
                is_satisfy_resolution_requirement: faker.helpers.arrayElement([
                  faker.datatype.boolean(),
                ]),
                is_satisfy_depth_requirements: faker.helpers.arrayElement([
                  faker.datatype.boolean(),
                ]),
                dpi_text: `${faker.number.int({ min: 30, max: 600 })} dpi`,
                pixel_number_text: `${faker.number.int({
                  min: 1,
                  max: 50,
                })}万画素`,
                width_and_height_pixel_text: `${faker.number.int({
                  min: 800,
                  max: 4000,
                })} * ${faker.number.int({ min: 600, max: 3000 })}`,
                rgb_depth_text: `RGB(${faker.number.int({
                  min: 100,
                  max: 256,
                })}, ${faker.number.int({
                  min: 100,
                  max: 256,
                })}, ${faker.number.int({
                  min: 100,
                  max: 256,
                })})`,
              },
              receipt_type: 'paper',
            },
          },
          {
            id: 'i0LAkK8hbNPbRL5C9I5vew',
            document_title: 'multiple_excise + multiple item.pdf',
            document_number: 'Doc-3',
            document_type: 'receipt',
            mf_file: {
              id: files,
              cache_content_url: '/mf_files/aMtZ0ldoqeJE7uTLFwyYLA',
              can_delete: false,
              byte_size: 400063,
              content_type: 'application/pdf',
              name: 'multiple_excise + multiple item_20250821194136.pdf',
            },
          },
          {
            id: 'N5yLO_aNpvuekQdvLI_ptA',
            document_title: 'multiple_page.pdf',
            document_number: 'Doc-2',
            document_type: 'contract',
            mf_file: {
              id: files,
              cache_content_url: '/mf_files/qZgtHZRBa7RQKW1wQ_Ii4g',
              can_delete: false,
              byte_size: 107884,
              content_type: 'application/pdf',
              name: 'multiple_page_20250821194106.pdf',
            },
          },
          {
            id: 'cqOAYGirucwN-IWVnLuRaw',
            document_title: 'invoice.jpg',
            document_number: 'Doc-1',
            document_type: 'not_specified',
            mf_file: {
              id: '69EnOKOHg0ojZMWwXxOwmg',
              cache_content_url: '/mf_files/69EnOKOHg0ojZMWwXxOwmg',
              can_delete: false,
              byte_size: 1081319,
              content_type: 'application/pdf',
              name: 'invoice_20250821194046.pdf',
            },
          },
          {
            id: 'cqOAYGirucwN-IWVnLuRaw2',
            document_title: 'invoice.jpg',
            document_number: 'Doc-12',
            document_type: 'not_specified',
            mf_file: {
              id: '69EnOKOHg0ojZMWwXxOwmg2',
              cache_content_url: '/mf_files/69EnOKOHg0ojZMWwXxOwmg2',
              can_delete: false,
              byte_size: 1081319,
              content_type: 'application/pdf',
              name: 'invoice_202508211940462.pdf',
            },
          },
          {
            id: 'cqOAYGirucwN-IWVnLuRaw3',
            document_title: 'invoice.jpg',
            document_number: 'Doc-13',
            document_type: 'not_specified',
            mf_file: {
              id: '69EnOKOHg0ojZMWwXxOwmg3',
              cache_content_url: '/mf_files/69EnOKOHg0ojZMWwXxOwmg3',
              can_delete: false,
              byte_size: 1081319,
              content_type: 'application/pdf',
              name: 'invoice_202508211940463.pdf',
            },
          },
        ],
      },
      {
        id: 'D5BNUhWSzgsrrXBkv3FlFQ',
        label: '費用計上日',
        type: 'ApReportFormInputInvoiceBookDateField',
        input_values: [
          {
            id: 'lDSxz4n4tNmyoHX4r3CigA',
            label: '2025/07/31',
            value: '2025/07/31',
          },
        ],
        input_additional_values: null,
      },
      {
        id: 'mqEI85YxjHAzGUHB4wdspQ',
        label: '支払期日',
        type: 'ApReportFormInputInvoiceDueDateField',
        input_values: [
          {
            id: 'D5BNUhWSzgsrrXBkv3FlFQ',
            label: '2025/08/29',
            value: '2025/08/29',
          },
        ],
        input_additional_values: null,
      },
      {
        id: 'xxYx9lMixO0VldIZrJHZqw',
        label: '目的',
        type: 'ApReportFormInputTextArea',
        input_values: [
          {
            id: 'mqEI85YxjHAzGUHB4wdspQ',
            label: 'note nha',
            value: 'note nha',
          },
        ],
        input_additional_values: null,
      },
      {
        id: 'encrypted_report_field_id_456',
        label: '事前申請番号',
        type: 'ApReportFormInputReportNumberForExpenseField',
        input_values: [
          {
            id: 'encrypted_report_value_id_0',
            label: 'AP001',
            value: 'https://ap.example.com/reports/AP001',
          },
          {
            id: 'encrypted_report_value_id_1',
            label: '002',
            value: 'https://ex.example.com/reports/002',
          },
          {
            id: 'encrypted_report_value_id_2',
            label: 'EXTERNAL123',
            value: null,
          },
        ],
        input_additional_values: null,
      },
      {
        id: 'FHmMaubNTUxGZSKRDbLhSA',
        label: 'sample 1',
        type: 'ApReportFormInputCheckBox',
        input_values: [
          { id: 'QgJzzSFkAq_8L7-xvidTEw', label: 'choice1', value: 'choice1' },
        ],
        input_additional_values: null,
      },
      {
        id: 'bQNwTp7SDTA3-bEJNBgkrg',
        label: 'sadasd',
        type: 'ApReportFormInputFileField',
        input_values: [
          {
            id: 'BzuyVCKrzewyK3oV3m3Blw',
            label:
              '\u003ca href="/mf_files/zlbSVn2PuxZygLY8ZQ7MCg"\u003emultiple_page.pdf\u003c/a\u003e',
            value: 'zlbSVn2PuxZygLY8ZQ7MCg',
          },
        ],
        input_additional_values: [
          {
            id: 'zlbSVn2PuxZygLY8ZQ7MCg',
            cache_content_url: '/mf_files/zlbSVn2PuxZygLY8ZQ7MCg',
            can_delete: true,
            byte_size: 98538,
            content_type: 'application/pdf',
            name: 'multiple_page.pdf',
          },
        ],
      },
      {
        id: 'pa1zjucgVH7mIxJoMIcaoQ',
        label: 'this is custom field',
        type: 'ApReportFormInputCheckBox',
        input_values: [
          { id: 'EsozNHgaMAl6NeVdFi_Jww', label: 'cb 2', value: 'cb 2' },
          { id: 'EsozNHgaMAl6NeVdFi_Jww', label: 'cb 3', value: 'cb 3' },
        ],
        input_additional_values: null,
      },
      {
        id: 'encrypted_contract_field_id_123',
        label: '契約番号',
        type: 'ApReportFormInputContractNumberField',
        input_values: [
          {
            id: 'encrypted_contract_value_id_0',
            label: 'CONTRACT001',
            value: 'https://stampless.example.com/contracts/CONTRACT001',
          },
          {
            id: 'encrypted_contract_value_id_1',
            label: 'CONTRACT002',
            value: null,
          },
          {
            id: 'encrypted_contract_value_id_2',
            label: 'CONTRACT003',
            value: 'https://stampless.example.com/contracts/CONTRACT003',
          },
        ],
        input_additional_values: null,
      },
      {
        id: 'RxfnqTtgHbb0qvXAxrHzWg',
        label: 'long text',
        type: 'ApReportFormInputTextArea',
        input_values: [
          {
            id: 'hmFAaveH4jxNAiD2r3cpbQ',
            label:
              'kjasdhjhkhjkasd asKJDHASKDJHAKDHSAhdashdkjsahjksahdsakjdh saKDHasd asDHASdhjkahhasdkjhasDJKHAKJ',
            value:
              'kjasdhjhkhjkasd asKJDHASKDJHAKDHSAhdashdkjsahjksahdsakjdh saKDHasd asDHASdhjkahhasdkjhasDJKHAKJ',
          },
        ],
        input_additional_values: null,
      },
      {
        id: '8Hbhy6Cf88uzNQl-ChGawA',
        label: 'numerical value ( branch conditions)',
        type: 'ApReportFormInputNumberFieldForBranch',
        input_values: [
          {
            id: 'f2PCVFeieX63CBAqwsVoWQ',
            label: '11,221,121',
            value: '11221121',
          },
        ],
        input_additional_values: null,
      },
      {
        id: 'a7-kutHUeRqpw_l0AKAJmg',
        label: 'radio button',
        type: 'ApReportFormInputRadioButton',
        input_values: null,
        input_additional_values: null,
      },
      {
        id: '__SRX5Ii-yyZDcBztkMWPg',
        label: 'dropdown',
        type: 'ApReportFormInputSelect',
        input_values: [
          { id: 's6FP_UpqBOmZygQ02REuJw', label: 'dd1', value: 'dd1' },
        ],
        input_additional_values: null,
      },
    ],
  };
};

// make a mock res like this SearchedApprovingInvoiceReport
export const getSearchApprovingInvoiceReportsMock = () => ({
  invoice_reports: Array.from({ length: 25 }, () => ({
    ap_payee_name: '株式会社テストクリエイティブソリューションズ',
    approved_at: '2025-04-30T00:00:00Z',
    book_date: '2025-04-30',
    created_at: '2025-04-30T00:00:00Z',
    detail_path: '/invoice_reports/AP1234',
    due_date: '2025-04-30',
    id: `AP${faker.number.int({ min: 1000, max: 9999 })}`,
    invoice_file: {
      byte_size: 1024,
      cache_content_url: '#',
      can_delete: false,
      content_type: 'application/pdf',
      id: 'file-1234',
      receipt_type: '電子取引',
      filename:
        'WPDW0000001_multiple_excise + multiple item_20250811111806.pdf',
    },
    is_approvable: faker.datatype.boolean(),
    is_editable: faker.datatype.boolean(),
    is_report_approval: faker.datatype.boolean(),
    is_waiting: faker.datatype.boolean(),
    number: `AP${faker.number.int({ min: 1000, max: 9999 })}`,
    office_member: {
      display_name: '田中一二三',
      id: '100',
      name: '田中一二三',
      number: '100',
    },
    report_approval_id: `AP${faker.number.int({ min: 1000, max: 9999 })}`,
    report_approval_names: '佐藤次郎,高橋敏徳,鈴木拓,山田太郎',
    status: (() => {
      const statusMap = [
        { key: 'approved', display_name: '承認済み' },
        { key: 'rejected', display_name: '差戻し' },
        { key: 'canceled', display_name: '取消し' },
        { key: 'waiting_step_one', display_name: '第一承認待ち' },
        { key: 'waiting_step_two', display_name: '第二承認待ち' },
      ];
      return statusMap[Math.floor(Math.random() * statusMap.length)];
    })(),
    submitted_at: '2025-04-30T00:00:00Z',
    title: '2025年5月支払依頼 - 詳細な説明と追加の情報を含む長いタイトル',
    total_amount: '100,000',
    foreign_currency_amount: '(100,000)',
    total_amount_with_currency: '100,000',
    automatic_status_waiting: (() => {
      const statusOptions = [
        AutomaticStatusWaiting.BEFORE_FLAIR_UPLOAD,
        AutomaticStatusWaiting.FLAIR_UPLOADED,
        AutomaticStatusWaiting.BEFORE_STREAMED_UPLOAD,
        AutomaticStatusWaiting.STREAMED_UPLOADED,
        AutomaticStatusWaiting.BEFORE_OCR_UPLOAD,
        AutomaticStatusWaiting.OCR_UPLOADED,
        undefined,
      ];
      return faker.helpers.arrayElement(statusOptions);
    })(),
    timestamp_status_creating: (() => {
      const timestampOptions = [TimestampStatusCreating.CREATING, undefined];
      return faker.helpers.arrayElement(timestampOptions);
    })(),
    error_messages: [
      {
        message_type: 'duplicate_reports_message',
        type: 'warn',
        label: '類似申請',
        message:
          '類似の支払依頼が申請されています。申請番号：AP90000（佐藤次郎）',
      },
      {
        message_type: 'report_edoc_scanner_message',
        type: 'error',
        label: 'スキャナ保存NG',
        message: '添付請求書の解像度もしくは階調が不足しています',
      },
      {
        message_type: 'invoice_file_edoc_scanner_message',
        type: 'error',
        label: 'スキャナ保存NG',
        message: '解像度もしくは階調が不足しています',
      },
    ],
  })),
  pagination: {
    has_next_page: true,
    has_previous_page: true,
    page: 1,
    per_page: 25,
    total_pages: 10,
    total_records: 250,
  },
});

export const getGetApprovingInvoiceReportApprovalMock = () => ({
  messages: ['success'],
  code: '200',
});

/** Mock for approval route */
export const getGetApprovingInvoiceReportApprovalRouteMock = () => ({
  steps: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => ({
      condition: faker.helpers.arrayElement([faker.word.sample()]),
      groups: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1
        ).map(() => ({
          approvals: faker.helpers.arrayElement([
            Array.from(
              { length: faker.number.int({ min: 1, max: 10 }) },
              (_, i) => i + 1
            ).map(() => ({
              approve_time: faker.helpers.arrayElement([faker.word.sample()]),
              approve_type: faker.helpers.arrayElement([faker.word.sample()]),
              approver_display_name: faker.helpers.arrayElement([
                faker.word.sample(),
              ]),
            })),
          ]),
          condition: faker.helpers.arrayElement([faker.word.sample()]),
          name: faker.helpers.arrayElement([faker.word.sample()]),
        })),
      ]),
      name: faker.helpers.arrayElement([faker.word.sample()]),
      status: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          'approved',
          'in_progress',
          'not_approved',
        ] as const),
      ]),
    })),
  ]),
  workflow_route: faker.helpers.arrayElement([
    { name: faker.helpers.arrayElement([faker.word.sample()]) },
  ]),
});

export const getGetApprovingInvoiceReportDisapprovalRouteMock = () => ({
  destinations: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 1 }) },
      (_, i) => i + 1
    ).map(() => ({
      name: faker.helpers.arrayElement([faker.word.sample()]),
      office_member_names: faker.helpers.arrayElement([
        Array.from(
          { length: faker.number.int({ min: 1, max: 10 }) },
          (_, i) => i + 1
        ).map(() => faker.word.sample()),
      ]),
      wf_step: faker.helpers.arrayElement([
        faker.helpers.arrayElement([
          faker.number.int({ min: undefined, max: undefined }),
          null,
        ]),
      ]),
    })),
  ]),
});

export const getCreateApprovingInvoiceReportDisapprovalMock = () => ({
  messages: faker.helpers.arrayElement([
    Array.from(
      { length: faker.number.int({ min: 1, max: 10 }) },
      (_, i) => i + 1
    ).map(() => faker.word.sample()),
  ]),
});

export const handlers = [
  http.post(
    '*/api/js/invoice_reports/approving_invoice_reports/search',
    async () => {
      await delay(1000);
      return new HttpResponse(
        JSON.stringify(getSearchApprovingInvoiceReportsMock()),
        {
          status: 200,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    }
  ),
  http.get(
    '*/api/js/invoice_reports/approving_invoice_reports/:id/payment_info',
    async () => {
      await delay(1000);
      return new HttpResponse(JSON.stringify(getGetPaymentInfoMock()), {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      });
    }
  ),
  http.get(
    '*/api/js/invoice_reports/approving_invoice_reports/:id/report_summary',
    async () => {
      await delay(1000);
      return new HttpResponse(JSON.stringify(getGetReportSummaryMock()), {
        status: 200,
        headers: {
          'Content-Type': 'application/json',
        },
      });
    }
  ),
  http.get(
    '*/api/js/invoice_reports/approving_invoice_reports/:id/journal',
    async () => {
      await delay(1000);
      return new HttpResponse(
        JSON.stringify(getGetApprovingInvoiceReportJournalMock()),
        {
          status: 200,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    }
  ),
  http.get(
    '*/api/js/invoice_reports/approving_invoice_reports/:id/approval_route',
    async () => {
      await delay(1000);
      return new HttpResponse(
        JSON.stringify(getGetApprovingInvoiceReportApprovalRouteMock()),
        {
          status: 200,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    }
  ),
  http.post(
    '*/api/js/invoice_reports/approving_invoice_reports/:id/approval',
    async () => {
      await delay(1000);
      return new HttpResponse(
        JSON.stringify(getGetApprovingInvoiceReportApprovalMock()),
        {
          status: 200,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    }
  ),
  http.get(
    '*/api/js/invoice_reports/approving_invoice_reports/:id/disapproval_route',
    async () => {
      await delay(1000);
      return new HttpResponse(
        JSON.stringify(getGetApprovingInvoiceReportDisapprovalRouteMock()),
        {
          status: 200,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    }
  ),
  http.post(
    '*/api/js/invoice_reports/approving_invoice_reports/:id/disapproval',
    async () => {
      await delay(1000);
      return new HttpResponse(
        JSON.stringify(getCreateApprovingInvoiceReportDisapprovalMock()),
        {
          status: 200,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    }
  ),
  http.get(
    '*/api/js/invoice_reports/approving_invoice_reports/business_documents/:id',
    async () => {
      await delay(1000);
      return new HttpResponse(
        JSON.stringify({
          id: faker.string.uuid(),
          searchable_number: faker.number.int({ min: 100000, max: 999999 }),
          document_title: faker.company.name() + ' 契約書',
          document_type: 'contract',
          filename: 'contract_document.pdf',
          counterparty_name: faker.company.name(),
          transaction_date: faker.date
            .recent({ refDate: FIXED_REF_DATE })
            .toISOString()
            .split('T')[0],
          amount: faker.number.int({ min: 10000, max: 1000000 }),
          memo: faker.lorem.sentence(),
          receipt_type: faker.helpers.arrayElement(['e_doc', 'paper']),
          timestamp_status: faker.helpers.arrayElement([
            'done',
            'creating',
            'unsupported',
            'failed',
          ]),
          automatic_status: faker.helpers.arrayElement([
            'ocr_done',
            'ocr_skipped',
          ]),
          pics: [
            {
              id: faker.string.uuid(),
              display_name: faker.person.fullName(),
              name: faker.person.fullName(),
            },
          ],
          uploader: {
            id: faker.string.uuid(),
            display_name: faker.person.fullName(),
            name: faker.person.fullName(),
          },
          uploaded_at: faker.date
            .recent({ refDate: FIXED_REF_DATE })
            .toISOString(),
          archived: false,
          upload_type: 'manual',
          mf_file: {
            id: faker.string.uuid(),
            name: 'contract_document.pdf',
            byte_size: faker.number.int({ min: 10000, max: 5000000 }),
            content_type: 'application/pdf',
            cache_content_url: 'https://example.com/mock-pdf.pdf',
          },
          e_doc_meta_datum: {
            dpi_text: '300dpi',
            pixel_number_text: `${faker.number.int({ min: 1, max: 50 })}万画素`,
            width_and_height_pixel_text: `${faker.number.int({
              min: 800,
              max: 4000,
            })} * ${faker.number.int({ min: 600, max: 3000 })}`,
            rgb_depth_text: '24bit',
            is_scan: true,
            is_satisfy_resolution_requirement: true,
            is_satisfy_depth_requirements: true,
          },
        }),
        {
          status: 200,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    }
  ),
];
